import { checkForDuplicateEnumValues } from '@app-utils/index';

/**
 * Enum representing different response codes.
 */
export enum ResponseCodeEnum {
  success = 'success',
  failed = 'failed',
  notFound = 'notFound', // data not found
  badRequest = 'badRequest', // Means data is invalid
  serverError = 'serverError', // some server error (try catch etc, which is not covered by defined cases and is in default else case)
  created = 'created',
  deleted = 'deleted',
  updated = 'updated',
  tooManyRequests = 'tooManyRequests',
  invalidRequest = 'invalidRequest', // invalid url/api request which does not exists in express app router/routes for that OnRequest expressHandler
  unAuthenticated = 'unAuthenticated',
  unAuthorized = 'unAuthorized',
  itemExists = 'itemExists',
}

/**
 * Enum representing different response status codes.
 */
export enum ResponseStatusEnum {
  success = 200,
  failed = 500,
  notFound = 404,
  badRequest = 400,
  created = 201,
  unAuthenticated = 401,
  unAuthorized = 403,
  tooManyRequests = 429,
  invalidRequest = 410,
  itemExists = 10001,
}

/**
 * Enum representing different request types.
 */
export enum RequestTypeEnum {
  get = 'get',
  post = 'post',
  put = 'put',
  delete = 'delete',
}

/**
 * Enum representing different link targets.
 */
export enum LinkTargetEnum {
  blank = '_blank',
}

/**
 * Enum representing different search parameter keys.
 */
export enum SearchParamKeysEnum {
  encryptedDataSearchParam = 's',
}

/**
 * Enum representing different request content types.
 */
export enum RequestContentTypeEnum {
  Json = 'application/json',
  FormData = 'multipart/form-data',
}

/**
 * Enum representing different request statuses.
 */
export enum RequestStatusEnum {
  approved = 1,
  rejected = 2,
}

/**
 * Enum representing different transfer methods.
 */
export enum TransferMethodEnum {
  easypaisa = 1,
  jazzcash = 2,
}

/**
 * Enum representing different query key types.
 */
export enum QueryKeyTypeEnum {
  id = 1,
  roomCode = 2,
  email = 3,
  phoneNumber = 4,
  uniqueId = 5, // our custom system generated uniqueId (what we give each user/item in db), not the "id/_id" autogenerated by db itself for each item
  pubgAppId = 6,
}

/**
 * Enum representing different process statuses.
 */
export enum ProcessStatusEnum {
  completed = 1,
  rejected = 2,
}

/**
 * Enum representing different boolean values.
 */
export enum BooleanEnum {
  true = 1,
  false = 0,
}

/**
 * Enum representing different variable types.
 */
export enum varTypesEnum {
  STRING = 'string',
  OBJECT = 'object',
  ARRAY = 'array',
  boolean = 'boolean',
  NUMBER = 'number',
  FUNCTION = 'function',
}

/**
 * Enum representing different platforms.
 */
export enum PlatformTypeEnum {
  web = 'web',
  android = 'android',
  ios = 'ios',
}

/**
 * Enum representing different time units.
 */
export enum TimeUnitEnum {
  Years = 'years',
  Months = 'months',
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes',
  Seconds = 'seconds',
  Milliseconds = 'milliseconds',
}

/**
 * Check for duplicate values in the PlatformTypeEnum.
 */
checkForDuplicateEnumValues(
  PlatformTypeEnum,
  'duplicate values in PlatformTypeEnum'
);

/**
 * Check for duplicate values in the ResponseCodeEnum.
 */
checkForDuplicateEnumValues(
  ResponseCodeEnum,
  'duplicate values in ResponseCodeEnum'
);

/**
 * Check for duplicate values in the ResponseStatusEnum.
 */
checkForDuplicateEnumValues(
  ResponseStatusEnum,
  'duplicate values in ResponseStatusEnum'
);

/**
 * Check for duplicate values in the RequestTypeEnum.
 */
checkForDuplicateEnumValues(
  RequestTypeEnum,
  'duplicate values in RequestTypeEnum'
);

/**
 * Check for duplicate values in the LinkTargetEnum.
 */
checkForDuplicateEnumValues(
  LinkTargetEnum,
  'duplicate values in LinkTargetEnum'
);

/**
 * Check for duplicate values in the SearchParamKeysEnum.
 */
checkForDuplicateEnumValues(
  SearchParamKeysEnum,
  'duplicate values in SearchParamKeysEnum'
);

/**
 * Check for duplicate values in the RequestContentTypeEnum.
 */
checkForDuplicateEnumValues(
  RequestContentTypeEnum,
  'duplicate values in RequestContentTypeEnum'
);

/**
 * Check for duplicate values in the RequestStatusEnum.
 */
checkForDuplicateEnumValues(
  RequestStatusEnum,
  'duplicate values in RequestStatusEnum'
);

/**
 * Check for duplicate values in the TransferMethodEnum.
 */
checkForDuplicateEnumValues(
  TransferMethodEnum,
  'duplicate values in TransferMethodEnum'
);

/**
 * Check for duplicate values in the QueryKeyTypeEnum.
 */
checkForDuplicateEnumValues(
  QueryKeyTypeEnum,
  'duplicate values in QueryKeyTypeEnum'
);

/**
 * Check for duplicate values in the ProcessStatusEnum.
 */
checkForDuplicateEnumValues(
  ProcessStatusEnum,
  'duplicate values in ProcessStatusEnum'
);

/**
 * Check for duplicate values in the BooleanEnum.
 */
checkForDuplicateEnumValues(BooleanEnum, 'duplicate values in BooleanEnum');

/**
 * Check for duplicate values in the varTypesEnum.
 */
checkForDuplicateEnumValues(varTypesEnum, 'duplicate values in varTypesEnum');

/**
 * Check for duplicate values in the TimeUnitEnum.
 */
checkForDuplicateEnumValues(TimeUnitEnum, 'duplicate values in TimeUnitEnum');
